import React from 'react';
import styled from 'styled-components';
import { Size } from 'lib/styles';
import shTitle from 'images/sh-ofmp-transparent-bg.png';
import { navigate } from 'hooks/useHookRouterCompat';

const Sidebar = styled.div`
  background: #18222B;
  display: flex;
  flex-direction: column;
  width: 220px;
  justify-content: flex-start;
  align-items: center;
  padding: ${Size.small} ${Size.medium} 0px;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Nav = styled.nav`
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
  padding: 0 30px;
  margin-top: 10px;
  flex: 1;
`;

const UserNav = styled.div`
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 30px;
  margin-bottom: 10px;
`;
export const Img = styled.img`
  height: auto;
  width: 80%;
  margin-top: 10px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  align-self: flex-start;
`;

export interface Props {
  navLinks: React.ReactNode;
  userLinks: React.ReactNode;
}

const PageSideNav = ({ navLinks, userLinks }: Props) => {

  return (
    <Sidebar>
      <Img alt="Seller Hub" onClick={() => navigate("/")} src={shTitle}/>
      <Nav>{navLinks}</Nav>
      <UserNav>{userLinks}</UserNav>
    </Sidebar>
  );
}

export default PageSideNav;